/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import getColor from "@insite/mobius/utilities/getColor";
import { sharedMyAccountDetailsLinesStyles } from "@monsma/App/ComponentExtensions/OrderLinesListExtension";
import { requisitionsProductListLineStyles } from "@monsma/Overrides/Widgets/Requisitions/RequisitionsProductListLine";
import { css } from "styled-components";

requisitionsProductListLineStyles.mainContainer = {
    gap: 10,
    css: css`
        padding: 20px 0;
    `,
};

requisitionsProductListLineStyles.selectedCheckbox = {};

requisitionsProductListLineStyles.quantityHeadingAndText = sharedMyAccountDetailsLinesStyles.smallHeadingAndTextContent;

requisitionsProductListLineStyles.xRequisitionsProductListLineStyles = {
    itemWrapper: {
        css: css`
            border-top: 1px solid ${getColor("common.ui12")};
        `,
    },
};
